import React from 'react';
import App from '../App.js';
import { MortgageGuideRoutes } from "GenericMortgageGuides";

function MortgageGuide(props) {
  const location = props.location
  const baseName = props.baseName
  const basePath = props.basePath
  const Footer = props.Footer

  console.log(location);
  console.log(baseName);
  console.log(basePath);

  return (
    <div className="App">
      {location === baseName || location === "/valoans/" ? <App /> : ""}
      {location !== baseName && location !== "/valoans/" ? (
        <MortgageGuideRoutes
          homePath={basePath}
          showHeader={true}
          showFooter={true}
          FooterComponent={Footer}
        />
      ) : (
        ""
      )}

    </div>
  );
}

export default MortgageGuide;
